import React from 'react';
import buttonStyles from '../../styles/buttons.module.css';
import { Skeleton } from '@mui/material';
import Render from '../Render';
import styles from './OrderHistory.module.css';

export default function OrderHistory(props) {
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>
        Order History
      </h2>
      <div style={{ padding: '15px', margin: 'auto' }}>
        <table className={styles.table}>
          <thead>
            <tr style={{ borderBottom: '2px solid #ddd' }}>
              <th className={styles.th1}>Order #</th>
              <th className={styles.th2}>Reference #</th>
              <th className={styles.th3}>Order Placed</th>
            </tr>
          </thead>
          <tbody>
            <Render if={props.error}>
              <tr>
                <td 
                  className={styles.error}
                  colSpan={3}
                >
                  Error fetching order history
                </td>
              </tr>
            </Render>
            {props.orders?.map((order) => {
              const date = new Date(order.purchase_date);
              const purchase_date = date.toLocaleDateString();
              return (
                <tr key={order.purchase_id}>
                  <td>
                    <a 
                      target="_blank" 
                      className={styles.order_num_link}
                      href={order.order_status_link}
                    >
                      {order.purchase_id}
                    </a>
                  </td>
                  <td className={styles.not_available}>
                    {order.purchase_cust_po || 'N/A'}
                  </td>
                  <td className={styles.purchase_date}>
                    {purchase_date}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <Render if={props.loading}>
          {[1, 2, 3, 4, 5].map((i) => (
            <Skeleton 
              variant="rectangular" 
              width={340} 
              height={17} 
              key={i} 
              style={{ margin: '10px 0' }}
            />
          ))}
        </Render>
      </div>
      <div className={styles.button}>
        <p>
          <a href="/account.php">
            <button className={buttonStyles.submitButton}>
              See all orders
            </button>
          </a>
        </p>
      </div>
    </div>
  );
}